import { useSearchParams } from "react-router-dom";

import {
  PRO014_ITEM_SORT,
  PRO014_ITEM_STATUS_FILTER,
  type Pro014ItemSort,
  type Pro014ItemStatusFilter,
} from "@/@types/campaign";
import { applyToSearchParams, readInt, readOneOf } from "@/utils/search-params";

import { PRODUCTS_DEFAULTS, PRODUCTS_FILTER_KEY } from "../constants";
import type { ProductsFilterKey, ProductsFilters, ProductsFiltersState } from "../types";

const STATUS_VALUES: Pro014ItemStatusFilter[] = Object.values(PRO014_ITEM_STATUS_FILTER);
const SORT_VALUES: Pro014ItemSort[] = Object.values(PRO014_ITEM_SORT);

export function useProductsFilters(): ProductsFiltersState {
  const [searchParams, setSearchParams] = useSearchParams();
  const storeCodeParam: string | null = searchParams.get(PRODUCTS_FILTER_KEY.STORE_CODE);

  const filters: ProductsFilters = {
    page: readInt(searchParams.get(PRODUCTS_FILTER_KEY.PAGE), PRODUCTS_DEFAULTS.PAGE),
    limit: readInt(searchParams.get(PRODUCTS_FILTER_KEY.LIMIT), PRODUCTS_DEFAULTS.LIMIT),
    status:
      readOneOf(searchParams.get(PRODUCTS_FILTER_KEY.STATUS), STATUS_VALUES) ??
      PRODUCTS_DEFAULTS.STATUS,
    search: searchParams.get(PRODUCTS_FILTER_KEY.SEARCH) ?? "",
    sort: readOneOf(searchParams.get(PRODUCTS_FILTER_KEY.SORT), SORT_VALUES) ?? PRODUCTS_DEFAULTS.SORT,
    storeCode: storeCodeParam ? Number(storeCodeParam) : undefined,
  };

  const updateFilter = (key: ProductsFilterKey, value: string): void => {
    const pageReset: Record<string, string> =
      key === PRODUCTS_FILTER_KEY.PAGE ? {} : { [PRODUCTS_FILTER_KEY.PAGE]: String(PRODUCTS_DEFAULTS.PAGE) };
    setSearchParams(applyToSearchParams(searchParams, { [key]: value, ...pageReset }));
  };

  return { filters, updateFilter };
}
